import type Eshop from '@eshop/type/eshop'

import css from './index.module.css'

interface Props {
    className?: string
    colorOnFull?: boolean
    hideCommonText?: boolean
    product: Eshop.Product<'availability'>
}

export const Availability = ({ className, colorOnFull, hideCommonText, product }: Props) => {
    let color = css.blue
    switch (product.availability.availabilityBranchCode) {
        case 'P00':
        case 'P01':
        case 'P05':
        case 'P06':
            color = css.green
            break
        case 'P02':
        case 'P04':
        case 'P07':
        case 'P08':
        case 'P10':
            color = css.red
            break
        case 'P03':
            color = css.blue
            break
        case 'P09':
            color = css.gray
            break
        default:
            color = css.blue
            break
    }
    return (
        <div className={`${css.wrap} ${className} ${colorOnFull ? color : ''}`.trim()}>
            <div className={colorOnFull ? undefined : color}>
                <strong>
                    {product.availability.availabilityBranchText}
                </strong>
            </div>
            {!hideCommonText && <div>{product.availability.availabilityCommonText}</div>}
        </div>
    )
}
